import React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
//import Link from '@mui/material/Link';
import { Link } from 'react-router-dom'
import GoogleLogin from 'react-google-login';
import Copyright from '../../../components/Copyright/Copyright';
import Error from '../../../Error/Error';
import '../Login.scss';

const LoginUsuariosView = ({ formik, loading, error, responseGoogle }) => {
    const theme = createTheme({
        typography: {
            fontSize: 14,
        },
    });

    return (
        <ThemeProvider theme={theme}>

            <Grid container component="main" sx={{ height: '100vh' }}>

                <CssBaseline />

                <Grid
                    item
                    xs={false}
                    sm={4}
                    md={7}
                    sx={{
                        backgroundImage: 'url(https://images.unsplash.com/photo-1618090584126-129cd1f3fbae?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=663&q=80)',
                        backgroundRepeat: 'no-repeat',
                        backgroundColor: (t) =>
                            t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }}
                />

                <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>

                    <Box
                        sx={{
                            my: 8,
                            mx: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <Avatar sx={{ m: 2, bgcolor: 'primary.main', width: "60px", height: "60px" }} />

                        <Typography component="h1" variant="h6" p="10">
                            Iniciar sesión
                        </Typography>

                        <Box
                            component="form"
                            noValidate
                            onSubmit={formik.handleSubmit}
                            sx={{ mt: 1 }}
                        >
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label="Ingresa tu email"
                                name="email"
                                autoComplete="email"
                                autoFocus
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                error={formik.touched.email && formik.errors.email}
                                helperText={formik.touched.email && formik.errors.email}
                            />
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Ingresa tu contraseña"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                error={formik.touched.password && formik.errors.password}
                            />
                            {/*        <FormControlLabel
                                control={<Checkbox value="remember" color="primary" />}
                                label="Recordame"
                            /> */}

                            {error.state && (<Error message={error.message} />)}

                            <div className="login__button--container">
                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{ mt: 3, mb: 2 }}
                                    disabled={loading || !formik.values.email || !formik.values.password}
                                >
                                    {loading ? <CircularProgress size={26} style={{ color: "white" }} /> : 'Iniciar Sesión'}
                                </Button>


                                <GoogleLogin
                                    clientId="422141246199-p70upemm6ulgs0644jolljlhmv8gk296.apps.googleusercontent.com"
                                    buttonText="Iniciar sesión"
                                    onSuccess={responseGoogle}
                                    onFailure={responseGoogle}
                                    cookiePolicy={'single_host_origin'}
                                    className='login__GoogleButton'
                                >
                                    {loading ? <CircularProgress size={26} style={{ color: "white" }} /> : 'Iniciar Sesión'}
                                </GoogleLogin>
                            </div>

                            <Grid container mt="10px">
                                <Grid item xs>
                                    <Link href="#" variant="body2">
                                        {" Olvide mi contraseña"}
                                    </Link>
                                </Grid>
                                <Grid item>
                                    <Link to='/registro/usuarios' variant="body2">
                                        {"¿No tenes cuenta? Registrate"}
                                    </Link>
                                </Grid>
                            </Grid>
                            <Grid marginTop={48}>
                                <Copyright sx={{ mt: 10 }} />
                            </Grid>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </ThemeProvider>
    )
}

export default LoginUsuariosView;
